import ApiClient from 'api-client/ApiClient'
import store from 'app/store'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import DeleteAction from 'core/actions/DeleteAction'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'

const { dispatch } = store
const { nova } = ApiClient.getInstance()

export const serverGroupActions = ActionsSet.make<DataKeys.ServerGroups>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.ServerGroups,
  cacheKey: DataKeys.ServerGroups,
})

export const listServerGroups = serverGroupActions.add(
  new ListAction<DataKeys.ServerGroups>(async () => {
    return nova.getServerGroups()
  }),
)

export const createServerGroup = serverGroupActions.add(
  new CreateAction<DataKeys.ServerGroups, { body }>(async ({ body }) => {
    const created = await nova.createServerGroup(body)
    return created
  }),
)

export const deleteServerGroup = serverGroupActions.add(
  new DeleteAction<DataKeys.ServerGroups, { id: string }>(async ({ id }) => {
    await nova.deleteServerGroup(id)
  }),
)

export const allServerGroupActions = ActionsSet.make<DataKeys.AllServerGroups>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.ServerGroups,
  cacheKey: DataKeys.AllServerGroups,
})

export const listAllServerGroups = allServerGroupActions.add(
  new ListAction<DataKeys.AllServerGroups>(async () => {
    return nova.getAllServerGroups()
  }),
)

export const getComputeQuotas = async ({ tenantId }: { tenantId: string }) => {
  const quotas = await nova.getQuotas({ id: tenantId })
  return quotas
}
